import * as React from 'react';
import { FeedbackPanel } from '@/components/index';
import classnames from 'classnames/bind';
import { inject } from 'mobx-react';
import { ForwardRefRenderFunction, useImperativeHandle } from 'react';
import Style from './index.less';

const $c = classnames.bind(Style);

export interface Props {
  type?: string;
}

export interface H5DraserRef {
  open(): void;
}

const H5Drawer: React.ForwardRefRenderFunction<H5DraserRef, Props> = (props, ref) => {
  const { type = 'ready' } = props;
  const [show, setShow] = React.useState<boolean>(false);

  useImperativeHandle(ref, () => {
    return {
      open() {
        setShow(true);
      },
    };
  });

  return (
    <div className={$c('drawer', { show })} onClick={() => setShow(false)}>
      <div className={$c('drawer-box')} onClick={e => e.stopPropagation()}>
        <FeedbackPanel onSubmit={() => setShow(false)} type={type} />
      </div>
    </div>
  );
};

const FeedbackPanelH5Drawer = React.forwardRef(H5Drawer);

export default FeedbackPanelH5Drawer;
